export default __webpack_public_path__ + "static/media/Or.a9bb1991.svg";